


























































































































































































































































































































































































import { editFactory } from '@/main/pages';
import { editName } from '@/main/store/listEditTypes';
import { showAlert } from '@/main/utils/notifications';
import { forceFileDownload, validateFiletype } from '@/main/utils/fileHelper';
import { saveButton, deleteButton } from '@/main/utils/tableOperations';
import { Cell, getColumnsRowMapObject } from '@/main/utils/table';
import { dropdownListProvider } from '@/main/dropdownApi';
import {
	UserRole,
	FILE_TYPE,
	MAXIMUM_FILE_SIZE,
} from '@/main/components/constants';

import { apiProvider } from './api';
import { store } from './store/edit';
import {
	NAME,
	CUSTOMER_FILES,
	DEPENDENT_TABLES,
	SUPPLIER_EDIT_HISTORY,
	VENDOR_STATUS,
	LOCAL_SUPPLIER,
} from './constants';

export default editFactory(NAME, store).extend({
	name: editName(NAME),
	data() {
		return {
			fileList: [] as any[],
			saveButton,
			deleteButton,
			dependencies: DEPENDENT_TABLES,
			CUSTOMER_FILES,
			SUPPLIER_EDIT_HISTORY,
		};
	},
	computed: {
		extraButtons(): {} {
			return {
				...saveButton(this.dodavatelFilesDownload),
				...deleteButton(this.dodavatelFilesDelete),
			};
		},
		isSupplierExists(): boolean {
			return this.DodavatelId !== null;
		},
		isApprovedBtnVisible(): boolean {
			return (
				this.IsApproved === VENDOR_STATUS.UnApproved
        && this.PrimaryUsers.includes(this.pracovnik.PracovnikId ? this.pracovnik.PracovnikId : 0)
			);
		},
		isLocalSupplier(): boolean {
			return (this.SupplierTypeId == LOCAL_SUPPLIER);
		},
	},
	methods: {
		async saveClick() {
			const LeadTime = this.DelieveryLeadTime;
			this.DelieveryLeadTime = null;
			this.startLoading();
			if (this.validateGSTIN() && this.dmsSys.EnableGSTPrp) {
				 const {
				 	data: isGstPanExistsResp,
				 } = await apiProvider.validateGSTINAndPAN(
				 	this.PAN,
				 	this.GSTIN,
				 	this.DodavatelId ? this.DodavatelId : 0,
				 );

				 if (isGstPanExistsResp) {
				 	showAlert({
				 		message: this.LocalizeChyboveHlasky('PANGSTIN'),
				 		title: this.LocalizeChyboveHlasky('errorTitle'),
				 		options: { type: 'error' },
				 	});
				 	this.endLoading();
				 	return;
				 }
			}

			const { data: isValidAbbrivation } = await apiProvider.validateAbbreviation(this.DodavatelZkt,
				this.DodavatelId ? this.DodavatelId : 0);
			if (!isValidAbbrivation) {
				showAlert({
					message: this.LocalizeChyboveHlasky('AbbrExistance'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				this.endLoading();
				return;
			}
			this.DelieveryLeadTime = LeadTime;
			const respDodavatelSave = await this.save();
			this.endLoading();

			if (respDodavatelSave instanceof Error) {
				showAlert({
					message: this.LocalizeChyboveHlasky('InvalidData'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'error' },
				});
			}
			/* This code is commented as no approval flow is required */
			/* } else {
				showAlert({
				 	message: this.LocalizeChyboveHlasky('ChangeReqRaised'),
				 	title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				 	options: { type: 'info' },
				});
			} */
		},
		validateGSTIN() {
			if (this.GSTIN != null) {
				const substr = this.GSTIN.substr(2, 10);
				if (this.PAN !== substr) {
					this.showErrorAlert({ message: 'InvalidGSTIN' });
					return false;
				}

				if (this.StatId !== null) {
					const gstStateCode = Number(this.GSTIN.substr(0, 2));
					if (this.StatId !== gstStateCode) {
						this.showErrorAlert({ message: 'InvalidGSTIN' });
						return false;
					}
				}
			}
			return true;
		},
		async approveSupplierRequest() {
			this.startLoading();
			await apiProvider.approveSupplierDetails(
				this.DodavatelId,
				this.ZakaznikId,
			);
			await this.refreshPage();
			this.endLoading();
		},
		async unApproveSupplierRequest() {
			if (this.SupplierRemarks === null || this.SupplierRemarks === '') {
				showAlert({
					message: this.LocalizeChyboveHlasky('RejectRmk'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
			} else {
				this.startLoading();
				await apiProvider.unApproveSupplierDetails(
					this.DodavatelId,
					this.SupplierRemarks,
					this.ZakaznikId,
				);
			}

			await this.refreshPage();
			this.endLoading();
		},
		async submitDodavatelFiles() {
			const validateFile = validateFiletype(
				this.fileList[0],
				MAXIMUM_FILE_SIZE,
				FILE_TYPE,
			);
			if (!validateFile.result) {
				showAlert({
					message: this.LocalizeChyboveHlasky(validateFile.message),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			this.startLoading();
			const { data: isFileUpload } = await apiProvider.saveDodavatelFileDocument(			
				this.fileList[0],
				this.ZakaznikId,
			);
			if (!isFileUpload) {
				this.endLoading();
				showAlert({
					message: this.LocalizeChyboveHlasky(validateFile.message),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
			this.fileList = [];
			await this.fetchTableSchemas([CUSTOMER_FILES]);
			await this.refreshTable(CUSTOMER_FILES);
			this.endLoading();
		},
		handleFileChange(file: Record<string, any>) {
			this.fileList = [file];
		},
		handleFileRemove(file: File, fileList: []) {
			this.fileList = fileList;
		},
		async dodavatelFilesDownload(e: Event, cells: Cell[]) {
			const MappedRow = getColumnsRowMapObject(
				this.dependentTables.CustomerFiles.columns,
				cells,
			) as any;
			this.startLoading();
			const file = await apiProvider.getDodavatelFileDocuments(
				MappedRow.FILE_ID,
			);
			const url = `data:application/octet-stream;base64,${file.data}`;
			forceFileDownload(url, MappedRow.FILE_NAME);
			this.endLoading();
		},

		async dodavatelFilesDelete(e: Event, cells: Cell[]) {
			await apiProvider.deleteDodavatelFileDocuments(cells[0]);
			await this.refreshTable(CUSTOMER_FILES);
		},
	},
});
